import { render, staticRenderFns } from "./programmeSimulation.vue?vue&type=template&id=6fd96db4&scoped=true"
import script from "./programmeSimulation.vue?vue&type=script&lang=js"
export * from "./programmeSimulation.vue?vue&type=script&lang=js"
import style0 from "./programmeSimulation.vue?vue&type=style&index=0&id=6fd96db4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fd96db4",
  null
  
)

export default component.exports